import { Hook } from "@oclif/core"
import { EnvHttpProxyAgent, setGlobalDispatcher } from "undici"

const hook: Hook.Init = async function () {
  setGlobalDispatcher(new EnvHttpProxyAgent())
}

export default hook
